import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import Contact from './Webpages/Contact';
import logoarrow from '../src/Assets/Image/trident-logo.jpg'
import AboutUs from './Webpages/AboutUs';
import Services from './Webpages/Services';
import IntroStrategySessions from './Webpages/IntroStrategySessions';

import { BiUpArrowAlt } from "react-icons/bi";
import { FaWhatsapp } from 'react-icons/fa';




// Pages
const App = () => {

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <BrowserRouter>

      <WebHeader />
      <div>
        <ScrollToTop />
        <Routes>

          <Route path="*" name="HomePage" element={<HomePage />} />
          <Route path="/" name="HomePage" element={<HomePage />} />
          <Route path="/contact" name="Contact" element={<Contact />} />
          <Route path="/aboutus" name="About" element={<AboutUs />} />
           <Route path="/services" name="Services" element={<Services />} />
          <Route path="/intro-strategy-sessions" name="IntroandStrategySession" element={<IntroStrategySessions/>} />
        


        </Routes>

        {/* <a
          href="https://wa.me/13122847077"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us!"
        >
          <FaWhatsapp />
        </a> */}


        {showScroll && (
          <button className="scroll-to-top show" onClick={scrollToTop}>
              <BiUpArrowAlt  className='scrollbtn' title="Scroll to Top" />
          </button>
        )}
      </div>
      <WebFooter />
    </BrowserRouter>
  )
}

export default App
